"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestId = void 0;
/**
 * Identifier for type of request to the ShapeDiver Platform Backend.
 */
var RequestId;
(function (RequestId) {
    /**
     * Platform Authentication API
     */
    RequestId["PasswordGrant"] = "password_grant";
    RequestId["RefreshToken"] = "refresh_token";
    RequestId["AuthorizationCode"] = "authorization_code";
    RequestId["Logout"] = "logout";
    RequestId["RequestAuthorizationCode"] = "request_authorization_code";
    /**
     * Platform Backend API
     */
    RequestId["ApiTokenGet"] = "api_token_get";
    RequestId["ApiTokenQuery"] = "api_token_query";
    RequestId["ApiTokenCreate"] = "api_token_create";
    RequestId["ApiTokenPatch"] = "api_token_patch";
    RequestId["ApiTokenDelete"] = "api_token_delete";
    RequestId["ApiClientQuery"] = "api_client_query";
    RequestId["ApiClientCreate"] = "api_client_create";
    RequestId["ApiClientPatch"] = "api_client_patch";
    RequestId["ApiClientDelete"] = "api_client_delete";
    RequestId["BackendSystemQuery"] = "backend_system_query";
    RequestId["BackendSystemCreate"] = "backend_system_create";
    RequestId["BackendSystemPatch"] = "backend_system_patch";
    RequestId["BackendSystemDelete"] = "backend_system_delete";
    RequestId["BackendSystemToken"] = "backend_system_token";
    RequestId["BookmarkCreate"] = "bookmark_create";
    RequestId["BookmarkDelete"] = "bookmark_delete";
    RequestId["ImageGet"] = "image_get";
    RequestId["ImageQuery"] = "image_query";
    RequestId["ImageCreate"] = "image_create";
    RequestId["ImagesDelete"] = "image_delete";
    RequestId["PolicyGet"] = "policy_get";
    RequestId["PolicyQuery"] = "policy_query";
    RequestId["PolicyCreate"] = "policy_create";
    RequestId["PolicyPatch"] = "policy_patch";
    RequestId["PolicyDelete"] = "policy_delete";
    RequestId["TagGet"] = "tag_get";
    RequestId["TagQuery"] = "tag_query";
    RequestId["TagDelete"] = "tag_delete";
    RequestId["TagPatch"] = "tag_patch";
    RequestId["TokenCreate"] = "token_create";
    RequestId["UserGet"] = "user_get";
    RequestId["UserQuery"] = "user_query";
    RequestId["UserPatch"] = "user_patch";
    RequestId["UserDelete"] = "user_delete";
    RequestId["UserRegister"] = "user_register";
    RequestId["UserConfirm"] = "user_confirm";
    RequestId["UserRefreshToken"] = "user_refresh_token";
    RequestId["UserDeleteRefreshToken"] = "user_delete_refresh_token";
    RequestId["UserDisableMailing"] = "user_disable_mailing";
    RequestId["UserToken"] = "user_token";
    RequestId["PasswordReset"] = "password_reset";
    RequestId["PasswordResetConfirm"] = "password_reset_confirm";
    RequestId["ModelGet"] = "model_get";
    RequestId["ModelQuery"] = "model_query";
    RequestId["ModelCreate"] = "model_create";
    RequestId["ModelPatch"] = "model_patch";
    RequestId["ModelDelete"] = "model_delete";
    RequestId["DecryptTicket"] = "decrypt_ticket";
    RequestId["ModelIframeData"] = "model_iframe_data";
    RequestId["SavedStateGet"] = "saved_state_get";
    RequestId["SavedStateQuery"] = "saved_state_query";
    RequestId["SavedStatePatch"] = "saved_state_patch";
    RequestId["SavedStateCreate"] = "saved_state_create";
    RequestId["SavedStateDelete"] = "saved_state_delete";
    RequestId["DomainGet"] = "domain_get";
    RequestId["DomainQuery"] = "domain_query";
    RequestId["DomainCreate"] = "domain_create";
    RequestId["DomainPatch"] = "domain_patch";
    RequestId["DomainDelete"] = "domain_delete";
    RequestId["OpenIDProviderGet"] = "openid_provider_get";
    RequestId["OpenIDProviderCreate"] = "openid_provider_create";
    RequestId["OpenIDProviderQuery"] = "openid_provider_query";
    RequestId["OpenIDProviderPatch"] = "openid_provider_patch";
    RequestId["OpenIDPRoviderDelete"] = "openid_provider_delete";
    RequestId["OrganizationGet"] = "organization_get";
    RequestId["OrganizationQuery"] = "organization_query";
    RequestId["OrganizationCreate"] = "organization_create";
    RequestId["OrganizationDelete"] = "organization_delete";
    RequestId["OrganizationPatch"] = "organization_patch";
    RequestId["OrganizationInvitationCreate"] = "organization_invitation_create";
    RequestId["OrganizationInvitationDelete"] = "organization_invitation_delete";
    RequestId["OrganizationInvitationsGet"] = "organization_invitation_get";
    RequestId["OrganizationInvitationAccept"] = "organization_invitation_accept";
    RequestId["OrganizationInvitationDeny"] = "organization_invitation_deny";
    RequestId["OrganizationPatchMemberRole"] = "organization_patch_member_role";
    RequestId["OrganizationInvitationByEmail"] = "organization_invitation_by_email";
    RequestId["OrganizationIdentifySSO"] = "organization_identify_sso";
    RequestId["OrganizationToken"] = "organization_token";
    RequestId["NotificationGet"] = "notification_get";
    RequestId["NotificationQuery"] = "notification_query";
    RequestId["NotificationCreate"] = "notification_create";
    RequestId["NotificationBatchCreate"] = "notification_batch_create";
    RequestId["NotificationPatch"] = "notification_patch";
    RequestId["NotificationDelete"] = "notification_delete";
    RequestId["NotificationSummary"] = "notification_summary";
    RequestId["NotificationReadAll"] = "notification_read_all";
    RequestId["UserModelSessionsQuery"] = "user_model_sessions_query";
    RequestId["UserCreditMetricsQuery"] = "user_credit_metrics_query";
    RequestId["OrganizationModelSessionsQuery"] = "organization_model_sessions_query";
    RequestId["OrganizationCreditMetricsQuery"] = "organization_credit_metrics_query";
    RequestId["ChargebeeHostedPage"] = "chargebee_hosted_page";
    RequestId["ChargebeeHostedPageUpdatePaymentMethod"] = "chargebee_hosted_page_update_payment_method";
    RequestId["ChargebeePortalSession"] = "chargebee_portal_session";
    RequestId["ChargebeeConfig"] = "chargebee_config";
    RequestId["ChargebeeQueryPlan"] = "chargebee_query_plan";
    RequestId["HttpLogQuery"] = "http_log_query";
    RequestId["ModelSharingCreate"] = "model_sharing_create";
    RequestId["ModelSharingCreateMultiple"] = "model_sharing_create_multiple";
    RequestId["ModelSharingQuery"] = "model_sharing_query";
    RequestId["ModelSharingQueryByModel"] = "model_sharing_query_by_model";
    RequestId["ModelSharingQueryByUser"] = "model_sharing_query_by_user";
    RequestId["ModelSharingGetByModelAndUser"] = "model_sharing_get_by_model_and_user";
    RequestId["ModelSharingDelete"] = "model_sharing_delete";
    RequestId["ModelSharingGroupedByuser"] = "model_sharing_grouped_by_user";
    RequestId["ModelSharingCopy"] = "model_sharing_copy";
    RequestId["SavedStateSharingCreate"] = "saved_state_sharing_create";
    RequestId["SavedStateSharingCreateMultiple"] = "saved_state_sharing_create_multiple";
    RequestId["SavedStateSharingQuery"] = "saved_state_sharing_query";
    RequestId["SavedStateSharingQueryBySavedState"] = "saved_state_sharing_query_by_saved_state";
    RequestId["SavedStateSharingQueryByUser"] = "saved_state_sharing_query_by_user";
    RequestId["SavedStateSharingGetBySavedStateAndUser"] = "saved_state_sharing_get_by_saved_state_and_user";
    RequestId["SavedStateSharingDelete"] = "saved_state_sharing_delete";
    RequestId["SavedStateSharingGroupedByuser"] = "saved_state_sharing_grouped_by_user";
    RequestId["WebhookChargebeeEvent"] = "webhook_chargebee_event";
    RequestId["WebhookModelMessage"] = "webhook_model_message";
    RequestId["WebhookNotification"] = "webhook_notification";
    RequestId["WebhookModelComputation"] = "webhook_model_computation";
    RequestId["WebhookModelExport"] = "webhook_model_export";
    RequestId["ModelTransferRequestCreate"] = "model_transfer_request_create";
    RequestId["ModelTransferRequestDelete"] = "model_transfer_request_delete";
    RequestId["ModelTransferRequestList"] = "model_transfer_request_list";
    RequestId["ModelTransferRequestGet"] = "model_transfer_request_get";
    RequestId["ModelTransferRequestAccept"] = "model_transfer_request_accept";
    RequestId["ModelTransferRequestDeny"] = "model_transfer_request_deny";
    RequestId["DocumentCreate"] = "document_create";
    RequestId["DocumentQuery"] = "document_query";
    RequestId["DocumentDelete"] = "document_delete";
    RequestId["DocumentList"] = "document_list";
    RequestId["DocumentDownload"] = "document_download";
    RequestId["DocumentView"] = "document_view";
    RequestId["DocumentAccept"] = "document_accept";
    RequestId["DocumentBrowserDownload"] = "document_browser_download";
    RequestId["DocumentBrowserView"] = "document_browser_view";
    RequestId["JobLogQuery"] = "job_log_query";
    RequestId["StargateGetConfig"] = "stargate_get_config";
})(RequestId = exports.RequestId || (exports.RequestId = {}));
//# sourceMappingURL=SdPlatformRequestId.js.map